import { render, staticRenderFns } from "./AccessProfile.vue?vue&type=template&id=66eb29a8&scoped=true&"
import script from "./AccessProfile.vue?vue&type=script&lang=ts&"
export * from "./AccessProfile.vue?vue&type=script&lang=ts&"
import style0 from "./AccessProfile.vue?vue&type=style&index=0&id=66eb29a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66eb29a8",
  null
  
)

export default component.exports